export default {
  // Page title
  title: "Push Record",
  
  // Search form
  searchForm: {
    pushTime: "Push Time",
    pushTimePlaceholder: "Please select time range",
    memberAccount: "Push Member",
    memberAccountPlaceholder: "Please enter",
    memberType: "Member Type",
    memberTypePlaceholder: "Please select",
    search: "Query",
    reset: "Reset"
  },
  
  // Table column titles
  table: {
    memberAccount: "Push Member",
    memberType: "Member Type",
    pushTitle: "Push Title",
    pushContent: "Push Content",
    pushTime: "Push Time",
    status: "Status",
    createTime: "Create Time"
  },
  
  // Member type
  memberType: {
    specify: "Specified Members",
    agent: "Agent",
    import: "Document Import",
    all: "All Members"
  },
  
  // Status
  status: {
    pending: "Pending",
    success: "Push Success",
    failed: "Push Failed"
  },
  
  // Pagination
  pagination: {
    total: "Total {total} records",
    pageInfo: "Page {currentPage}/{totalPages}",
    itemsPerPage: "items/page",
    jumpTo: "Jump to",
    page: "page"
  },
  
  // Messages
  messages: {
    fetchDataFailed: "Failed to fetch data",
    noData: "No data",
    timeRangeExceeded: "Query time range cannot exceed 1 month, please reselect."
  }
};
